import './hacienda/style';
import FormStructure from './hacienda/form_structure';

export default FormStructure;